module.exports = __webpack_public_path__ + "img/Step3.f24adb05.png";